/**
 * Created by katarinababic on 14.5.25.
 */
import * as React from 'react';
import { observer } from 'mobx-react';
import { useEffect } from 'react';
import { ExerciseSet } from '../../../Model/WorkoutLog/ExerciseSet';
import { BaseTrackingKey } from '../../../Model/ProgramPortfolio/TrackingKeys';
import { EndWorkoutEditResultsTrackingKeys } from './ExerciseRun/EndWorkoutEditResultsTrackingKeys';

export type EndWorkoutOverviewSetsListItemProps = {
  set: ExerciseSet;
  index: number;
};

export const EndWorkoutOverviewSetsListItem: React.FC<EndWorkoutOverviewSetsListItemProps> = observer(
  ({ set, index }) => {
    const nonDurationTrackingKeys = Array.from(set?.values.keys()).filter(
      (key) => key !== 'DURATION' && key !== 'BREAK' && !key.startsWith('MIN_') && !key.startsWith('MAX_'),
    ) as BaseTrackingKey[]; // @TODO quite a hack

    const trackingKeys =
      nonDurationTrackingKeys.length === 0
        ? (Array.from(set?.values.keys()).filter(
            (key) => key !== 'BREAK' && !key.startsWith('MIN_') && !key.startsWith('MAX_'),
          ) as BaseTrackingKey[])
        : nonDurationTrackingKeys;

    return (
      <div>
        {trackingKeys.map((key, idx, self) => (
          <EndWorkoutEditResultsTrackingKeys key={key} trackingKey={key} set={set} isLast={self.length === idx + 1} />
        ))}
      </div>
    );
  },
);
